import { API_ROUTES } from "@/constants/api";
import type { Schedule } from "@/components/Shared/ScheduleDisplay";

export type CourseClassroom = {
  course: string;
  classroom: string;
  initialDate: string;
  mode?: string;
  officeLocation?: string;
  schedule?: Schedule[];
};

export async function findCourseClassroom(
  courseSlug: string,
  classroomParam: string
): Promise<CourseClassroom | null> {
  const response = await fetch(
    `${API_ROUTES.COURSES_WITH_CLASSROOMS}?courseName=${courseSlug}&classroom=${encodeURIComponent(classroomParam)}`
  );
  if (!response.ok) {
    throw new Error("Failed to fetch course classrooms");
  }
  const classrooms: CourseClassroom[] = await response.json();
  return classrooms[0]?.course ? classrooms[0] : null;
}
